import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { status as AppointmentStatusIds } from '@spike/appointment-model';
import { WorkflowStepAction } from '@spike/masterdata-model';
import { FunctionComponent } from 'react';

export interface ListItemProps {
    step: WorkflowStepAction;
    className?: string;
    onClick?: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            padding: '10px 0px',
            cursor: 'pointer'
        },
        label: isRed => ({
            color: isRed ? '#EF4F57' : '#000',
            fontSize: 14,
            lineHeight: '100%',
            fontWeight: 500
        })
    })
);

export const redAppointementStatusIds = [
    AppointmentStatusIds.CANCELLED,
    AppointmentStatusIds.NO_SHOW,
    AppointmentStatusIds.DECLINED
];

const actionStatusIds = [AppointmentStatusIds.CANCELLED, AppointmentStatusIds.NO_SHOW, AppointmentStatusIds.DECLINED];

const getLabel = (step: WorkflowStepAction) =>
    actionStatusIds.includes(step.nextStatus.id) ? step.action : step.nextStatus.name;

export const ListItem: FunctionComponent<ListItemProps> = props => {
    const isRed = redAppointementStatusIds.includes(props.step.nextStatus.id);
    const classes = useStyles(isRed);

    const clickHandler = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        props.onClick && props.onClick();
    };
    return (
        <Box
            className={classes.container}
            onClick={clickHandler}
        >
            <Typography className={classes.label}>{getLabel(props.step)}</Typography>
        </Box>
    );
};

export default ListItem;
